import { UploadFile } from 'antd/lib/upload/interface';
import { Storage } from 'aws-amplify';
import { Entity } from '~core/domain/Entity';
import { PartialRequired } from '~types/utils';

export type VideoType = {
  directory: string;
} & PartialRequired<UploadFile, 'size' | 'type'>;

type VideoTypeJson = VideoType;

export class Video extends Entity<VideoType> {
  private constructor(params: VideoType) {
    super(params);
  }

  static async create({ ...video }: VideoTypeJson) {
    return new Video({
      ...video,
      size: video.size ?? 0,
      type: video.type ?? 'video',
      // thumbUrl:
      //   (video.originFileObj &&
      //     (await Video.generateThumbnailByFile(video.originFileObj as File))) ||
      //   (video.url && (await Video.generateThumbnailByUrl(video.url))),
    });
  }

  private get extension() {
    return this.name && /\.([^.]*)$/.exec(this.name)?.[1];
  }

  async upload() {
    const { key } = (await Storage.put(
      `${this.directory}${this.uid}.${this.extension}`,
      this.originFileObj
    )) as { key: string };

    return key;
  }

  static async generateThumbnailByFile(file: File) {
    return new Promise<string>((resolve, reject) => {
      try {
        const canvas = document.createElement('canvas');
        const video = document.createElement('video');

        video.autoplay = true;
        video.muted = true;
        video.src = URL.createObjectURL(file);

        video.onloadeddata = () => {
          const ctx = canvas.getContext('2d');
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;

          ctx?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          video.pause();

          const thumbnail = canvas.toDataURL('image/png');
          return resolve(thumbnail);
        };
      } catch (error) {
        reject(error);
      }
    });
  }

  static async generateThumbnailByUrl(url: string) {
    const response = await fetch(url).catch(() => undefined);
    if (response?.status !== 200) {
      return;
    }

    const blob = await response.blob();
    const fileName = url.match(/.+\/([^?]+)+\??.*$/)?.[1];

    try {
      const file = new File([blob], fileName ?? 'movie.mp4', {
        type: 'video/mp4',
      });
      const thumbnail = await Video.generateThumbnailByFile(file);
      return thumbnail;
    } catch (error) {
      console.error(error);
      return;
    }
  }

  async delete() {
    const { key } = await Storage.remove<any>(
      `${this.directory}${this.uid}.${this.extension}`
    );

    return key;
  }
}
